import * as Actions from '../../../../redux/actions';

import React, { Component } from 'react'

import { Menu } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { profile_router } from '../../Common/RegExValidate';

class MenuProfile_ extends Component {
    render() {

        const { switch_container, setSwitchProfileContainer, screenSize, token } = this.props;
        let nav_menu_width = "240"

        let screen_at_500 = 500
        if (!isNaN(screenSize)) {
            nav_menu_width = screenSize < screen_at_500 ? screenSize / 3 : "240"
        }
        return (
            <Menu pointing secondary style={{ backgroundColor: "#191919", borderBottom: "0", paddingTop: "10px" }}>

                <div className={switch_container === profile_router.interests ? "menu_link_title_text_create_account_active p-0 m-0" : "menu_link_title_text_create_account p-0 m-0"}
                    onClick={
                        token !== undefined && token !== "" ?
                            () => setSwitchProfileContainer(profile_router.interests)
                            :
                            () => { }
                    }
                    style={{
                        width: nav_menu_width + "px",
                        cursor: token !== undefined && token !== "" ? "pointer" : "",
                    }}>1. {profile_router.interests}</div>
                <div className={switch_container === profile_router.bio ? "menu_link_title_text_create_account_active p-0 m-0" : "menu_link_title_text_create_account p-0 m-0"}
                    onClick={
                        token !== undefined && token !== "" ?
                            () => setSwitchProfileContainer(profile_router.bio)
                            :
                            () => { }
                    }
                    style={{
                        width: nav_menu_width + "px",
                        cursor: token !== undefined && token !== "" ? "pointer" : "",
                    }}>2. {profile_router.bio}</div>
                <div className={switch_container === profile_router.profile ? "menu_link_title_text_create_account_active p-0 m-0" : "menu_link_title_text_create_account p-0 m-0"}
                    onClick={
                        token !== undefined && token !== "" ?
                            () => setSwitchProfileContainer(profile_router.profile)
                            :
                            () => { }
                    }
                    style={{
                        width: nav_menu_width + "px",
                        cursor: token !== undefined && token !== "" ? "pointer" : "",
                    }}>3. {profile_router.profile}</div>
                <div className={switch_container === profile_router.personalization ? "menu_link_title_text_create_account_active p-0 m-0" : "menu_link_title_text_create_account p-0 m-0"}
                    onClick={
                        token !== undefined && token !== "" ?
                            () => setSwitchProfileContainer(profile_router.personalization)
                            :
                            () => { }
                    }
                    style={{
                        width: nav_menu_width + "px",
                        cursor: token !== undefined && token !== "" ? "pointer" : "",
                    }}>4. {profile_router.personalization}</div>
            </Menu>
        )
    }
}


const mapStateToProps = (state) => ({
    screenSize: state.Setting.htmlBody.bodyClientWidth,
    switch_container: state.Member.profile_container,
    app_menu_height: state.Setting.appMenu.app_menu_height,
    is_mobile: state.Setting.is_mobile,
    token: state.Member.authModal.token,
})

const mapDispatchToProps = {
    setSwitchProfileContainer: Actions.setSwitchProfileContainer,
}

const MenuProfile = connect(mapStateToProps, mapDispatchToProps)(MenuProfile_)
export default MenuProfile
